import { memo } from 'react'
import {
    buildControlsExt,
    dateTimePicker,
} from '../inputs/controls'
import { TimeFormats } from '../models/DateTime/types'

interface DateFromFilterProps {
    inputState: any
    setInputState: Function
}

export const DateFromFilter = memo(function DateFromFilter(
    props: DateFromFilterProps
) {
    const { inputState, setInputState } = props

    const dateFromPicker = buildControlsExt(
        [
            dateTimePicker(
                'from',
                {
                    className: 'mb-2 label-sm',
                    timeFormat: TimeFormats.DATE,
                },
                false,
                true
            ),
        ],
        inputState,
        setInputState
    )

    return (
        <div className=" d-flex flex-column gap-1">
            <span>From</span>
            <div className="w-100">
                {dateFromPicker}
            </div>
        </div>
    )
})
